module.exports = __webpack_public_path__ + "static/media/exclusive-access.64dc98b5.svg";